import React, { useState, useEffect } from "react";
import { CommonPanditSelect, CommonDateTimePicker } from "../common";
import { EpujaOrder, User } from "../../types/interfaces";
import useAxios from "../../hooks/useAxios";

type ModalProps = {
  show: boolean;
  handleModalOpenClose: (show: boolean) => void;
  orderType: string;
  order_id: string;
  getListData: () => void;
};


const AssignPanditModal: React.FC<ModalProps> = ({ show, handleModalOpenClose, orderType, order_id, getListData }) => {
  const axiosInstance = useAxios();
  const [selectedpandit, setSelectedPandit] = useState<User>(null);;
  const [selecteddate, setSelectedDate] = useState<string>(null);;
  const [panditerror, setPanditError] = useState("");
  const [dateerror, setDateError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  useEffect(() => {
	 if(!selectedpandit){
		 setPanditError("");
	 } 
  }, [selectedpandit]);
  
  
  /*Submit Form*/
  const handleSubmit = async () => {
	  if(!selectedpandit){
		  setPanditError("Select pandit to assign.");
		  return false;
	  }
	  if(orderType === 'epuja' && !selecteddate){
		  setPanditError("Select pandit to assign.");
		  return false;
	  }
      setIsSubmitting(true);
      try {
		let endpoint = orderType === 'epuja' ?  "epuja-orders/assign-pandit" : "kundli-prediction-order/assign-pandit"; 
        const response: any = await axiosInstance({
          url: endpoint,
          method: "POST",
		  data: {pandit_id: selectedpandit._id, selected_date: selecteddate, order_id},
        });
        //console.log('create/update response', response.data)
        //on success close the modal
        if (!response.error) {
		  getListData();	
          handleClose();
        }
      } catch (error: any) {
        console.error('Error in api request:', error);
      } finally {
        setIsSubmitting(false);
      }
  };
  
  const handleClose = () => {
    setPanditError("");
    setDateError("");
    setSelectedPandit(null);
    setSelectedDate(null);
    handleModalOpenClose(false);
  };
  //console.log('selected', selected);
  return (
    <>
	  <div
        className="modal fade show"
        tabIndex={-1}
        aria-modal="true"
        role="dialog"
        style={{ display: "block" }}
      >
        <div className="modal-dialog modal-dialog-centered mw-650px">
          <div className="modal-content position-relative">
            {/* Close button */}
            <button
              type="button"
              className="btn btn-icon btn-active-color-primary position-absolute"
              style={{ top: "10px", right: "10px", zIndex: 10 }}
              onClick={handleClose}
            >
              ✖
            </button>
			  <div className="modal-header">
				<h2>Assign Pandit</h2>
			  </div>
			  <div className="modal-body mx-xl-5">
				<form className="form">
				  <CommonPanditSelect
				      show_label={true}
					  label="Select Pandit"
					  selectedValue={selectedpandit}
					  onChange={(pandit) => setSelectedPandit(pandit || null)}
					  is_required={true}
					  error={panditerror}
				   />
				  {orderType === 'epuja' && (
				    <div className="mt-4">
				      <CommonDateTimePicker 
					    field_name="Pooja Date"
					    handleInputChange={(date) => setSelectedDate(date.value || null)}
						disablePast={true}
					  />
				    </div>
				  )}	
				  <div className="border-top mb-5 mt-5" />
				  <div className="text-end">
					<button
					  type="button"
					  className="btn btn-light me-3"
					  onClick={handleClose}
					>
					  Cancel
					</button>
					{isSubmitting ? (
					  <button
						type="button"
						id="kt_modal_new_card_submit"
						className="btn btn-primary"
						disabled={true}
					  >
						<span
						  className="indicator-progress"
						  style={{ display: "block" }}
						>
						  Please wait...
						  <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
						</span>
					  </button>
					) : (
					  <button
						type="button"
						id="kt_modal_new_card_submit"
						className="btn btn-primary"
						onClick={handleSubmit}
					  >
						<span className="indicator-label">Submit</span>
					  </button>
					)}
				  </div>
				</form>
			  </div>
			</div>
         </div>
      </div>
	  <div className="modal-backdrop fade show" />
    </>
  );
};

export default AssignPanditModal;
